<div class="flex min-h-screen items-center justify-center bg-gray-50">
  <router-outlet />
</div>
